import { lazyLoad } from 'utils/loadable';

export const EducationWrapperLoadable = lazyLoad(
  () => import('./EducationWrapper'),
  module => module.EducationWrapper,
);
